import React from "react";
import { useFormikContext } from "formik";
import TextInput from "../../../../../components/form/text-input";
import { Select } from "../../../../../components/form/select";
import styles from "../style.module.scss";
import baseStyles from "../style.module.scss";
import pricingValidation from "../../../../../../components/modals/add-new-application-modal/pricing-validation";
import SlidingToggle from "../../../../../components/form/sliding-checkbox";
import useUserStore from "../../../../../stores/user";
import useOrganizationStore from "../../../../../stores/organization";
import { getSoftLimitWarning } from "../../../utils/soft-limit";
import { PaylianceIndustries } from "../../../../../../constants";
import { hasAchProcessor } from "../../../utils/processor-pricing-rules";

const achValidation = pricingValidation.pricingValidation.ach;

const ACHPricing = ({ showPaylianceIndustry = false }) => {
  const { values, errors, touched, handleBlur, handleChange, setFieldValue } =
    useFormikContext();

  const user = useUserStore((state) => state.user);
  const pricingDefaults = useOrganizationStore(
    (state) => state.pricingDefaults,
  );
  const nonEditableTemplateOrPricingRestricted =
    values.nonEditableTemplateApplied ||
    user?.organization?.pricing_restricted === 1;

  return (
    <>
      <div className={baseStyles.card}>
        <h6 className={baseStyles.card_heading}>ACH Pricing</h6>

        <div className={baseStyles.card_body}>
          {showPaylianceIndustry && hasAchProcessor(values.processors) && (
            <div
              className={`${baseStyles.grid} ${baseStyles.gridCols2} ${baseStyles.gap1}`}
            >
              <Select
                label="Payliance Industry"
                placeholder="Select Payliance Industry"
                id="payliance_industry"
                name="payliance_industry"
                search
                onBlur={handleBlur}
                options={PaylianceIndustries}
                value={values.payliance_industry}
                onChange={(value) =>
                  setFieldValue(
                    "payliance_industry",
                    typeof value === "object" ? value.value : value,
                  )
                }
                touched={touched?.payliance_industry}
                errored={errors.payliance_industry}
                error={errors.payliance_industry}
              />
            </div>
          )}
          <div
            className={`${baseStyles.grid} ${baseStyles.gridCols2} ${baseStyles.gap1}`}
          >
            <TextInput
              label="Discount rate"
              name="ach_discount_rate"
              type="text"
              suffix={"%"}
              inputMode="decimal"
              placeholder={achValidation.ach_discount_rate.default}
              value={values.ach_discount_rate}
              onChange={() => { }}
              onBlur={handleBlur}
              touched={touched?.ach_discount_rate}
              errored={errors?.ach_discount_rate}
              error={errors?.ach_discount_rate}
              hasWarning={getSoftLimitWarning(
                pricingDefaults?.ach?.ach_discount_rate?.soft_limit,
                values.ach_discount_rate,
                errors.ach_discount_rate,
              )}
              disabled={nonEditableTemplateOrPricingRestricted}
              cleaveOptions={{
                numeral: true,
                numeralDecimalScale: 2,
                numeralDecimalMark: ".",
                onValueChanged: (e) => {
                  handleChange({
                    target: {
                      name: "ach_discount_rate",
                      value: e.target.rawValue,
                    },
                  });
                },
              }}
            />

            <TextInput
              label="Transaction fee per item"
              name="ach_transaction_fee_per_item"
              type="text"
              prefix={"$"}
              suffix={"/txn"}
              inputMode="decimal"
              placeholder={achValidation.ach_transaction_fee_per_item.default}
              value={values.ach_transaction_fee_per_item}
              onChange={() => { }}
              onBlur={handleBlur}
              touched={touched?.ach_transaction_fee_per_item}
              errored={errors?.ach_transaction_fee_per_item}
              error={errors?.ach_transaction_fee_per_item}
              hasWarning={getSoftLimitWarning(
                pricingDefaults?.ach?.ach_transaction_fee_per_item?.soft_limit,
                values.ach_transaction_fee_per_item,
                errors.ach_transaction_fee_per_item,
              )}
              disabled={nonEditableTemplateOrPricingRestricted}
              cleaveOptions={{
                numeral: true,
                numeralDecimalScale: 2,
                numeralDecimalMark: ".",
                onValueChanged: (e) => {
                  handleChange({
                    target: {
                      name: "ach_transaction_fee_per_item",
                      value: e.target.rawValue,
                    },
                  });
                },
              }}
            />
          </div>
        </div>
      </div>

      <div className={baseStyles.card}>
        <h6 className={baseStyles.card_heading}>Additional Fees</h6>

        <div className={baseStyles.card_body}>
          <div className={styles.additionalFees}>
            <TextInput
              label="Statement fee"
              name="ach_statement_fee"
              type="text"
              prefix={"$"}
              inputMode="decimal"
              placeholder={achValidation.ach_statement_fee.default}
              value={values.ach_statement_fee}
              onBlur={handleBlur}
              onChange={() => { }}
              touched={touched?.ach_statement_fee}
              errored={errors?.ach_statement_fee}
              error={errors?.ach_statement_fee}
              hasWarning={getSoftLimitWarning(
                pricingDefaults?.ach?.ach_statement_fee?.soft_limit,
                values.ach_statement_fee,
                errors.ach_statement_fee,
              )}
              disabled={nonEditableTemplateOrPricingRestricted}
              cleaveOptions={{
                numeral: true,
                numeralDecimalScale: 2,
                numeralDecimalMark: ".",
                onValueChanged: (e) => {
                  handleChange({
                    target: {
                      name: "ach_statement_fee",
                      value: e.target.rawValue,
                    },
                  });
                },
              }}
            />

            <TextInput
              label="Monthly minimum"
              name="ach_monthly_minimum"
              type="text"
              prefix={"$"}
              inputMode="decimal"
              placeholder={achValidation.ach_monthly_minimum.default}
              value={values.ach_monthly_minimum}
              onBlur={handleBlur}
              onChange={() => { }}
              touched={touched?.ach_monthly_minimum}
              errored={errors?.ach_monthly_minimum}
              error={errors?.ach_monthly_minimum}
              hasWarning={getSoftLimitWarning(
                pricingDefaults?.ach?.ach_monthly_minimum?.soft_limit,
                values.ach_monthly_minimum,
                errors.ach_monthly_minimum,
              )}
              disabled={nonEditableTemplateOrPricingRestricted}
              cleaveOptions={{
                numeral: true,
                numeralDecimalScale: 2,
                numeralDecimalMark: ".",
                onValueChanged: (e) => {
                  handleChange({
                    target: {
                      name: "ach_monthly_minimum",
                      value: e.target.rawValue,
                    },
                  });
                },
              }}
            />

            <TextInput
              label="Return fee"
              name="ach_return_fee"
              type="text"
              prefix={"$"}
              inputMode="decimal"
              placeholder={achValidation.ach_return_fee.default}
              value={values.ach_return_fee}
              onBlur={handleBlur}
              onChange={() => { }}
              touched={touched?.ach_return_fee}
              errored={errors?.ach_return_fee}
              error={errors?.ach_return_fee}
              hasWarning={getSoftLimitWarning(
                pricingDefaults?.ach?.ach_return_fee?.soft_limit,
                values.ach_return_fee,
                errors.ach_return_fee,
              )}
              disabled={nonEditableTemplateOrPricingRestricted}
              cleaveOptions={{
                numeral: true,
                numeralDecimalScale: 2,
                numeralDecimalMark: ".",
                onValueChanged: (e) => {
                  handleChange({
                    target: {
                      name: "ach_return_fee",
                      value: e.target.rawValue,
                    },
                  });
                },
              }}
            />

            <TextInput
              label="NOC fee"
              name="ach_noc_fee"
              type="text"
              prefix={"$"}
              inputMode="decimal"
              placeholder={achValidation.ach_noc_fee.default}
              value={values.ach_noc_fee}
              onBlur={handleBlur}
              onChange={() => { }}
              touched={touched?.ach_noc_fee}
              errored={errors?.ach_noc_fee}
              error={errors?.ach_noc_fee}
              hasWarning={getSoftLimitWarning(
                pricingDefaults?.ach?.ach_noc_fee?.soft_limit,
                values.ach_noc_fee,
                errors.ach_noc_fee,
              )}
              disabled={nonEditableTemplateOrPricingRestricted}
              cleaveOptions={{
                numeral: true,
                numeralDecimalScale: 2,
                numeralDecimalMark: ".",
                onValueChanged: (e) => {
                  handleChange({
                    target: {
                      name: "ach_noc_fee",
                      value: e.target.rawValue,
                    },
                  });
                },
              }}
            />

            <TextInput
              label="Unauthorized return fee"
              name="ach_unauthorized_return_fee"
              type="text"
              prefix={"$"}
              inputMode="decimal"
              placeholder={achValidation.ach_unauthorized_return_fee.default}
              value={values.ach_unauthorized_return_fee}
              onBlur={handleBlur}
              onChange={() => { }}
              touched={touched?.ach_unauthorized_return_fee}
              errored={errors?.ach_unauthorized_return_fee}
              error={errors?.ach_unauthorized_return_fee}
              hasWarning={getSoftLimitWarning(
                pricingDefaults?.ach?.ach_unauthorized_return_fee?.soft_limit,
                values.ach_unauthorized_return_fee,
                errors.ach_unauthorized_return_fee,
              )}
              disabled={nonEditableTemplateOrPricingRestricted}
              cleaveOptions={{
                numeral: true,
                numeralDecimalScale: 2,
                numeralDecimalMark: ".",
                onValueChanged: (e) => {
                  handleChange({
                    target: {
                      name: "ach_unauthorized_return_fee",
                      value: e.target.rawValue,
                    },
                  });
                },
              }}
            />

            <TextInput
              label="Same day ACH fee"
              name="ach_same_day_fee"
              type="text"
              prefix={"$"}
              inputMode="decimal"
              placeholder={achValidation.ach_same_day_fee.default}
              value={values.ach_same_day_fee}
              onBlur={handleBlur}
              onChange={() => { }}
              touched={touched?.ach_same_day_fee}
              errored={errors?.ach_same_day_fee}
              error={errors?.ach_same_day_fee}
              hasWarning={getSoftLimitWarning(
                pricingDefaults?.ach?.ach_same_day_fee?.soft_limit,
                values.ach_same_day_fee,
                errors.ach_same_day_fee,
              )}
              disabled={nonEditableTemplateOrPricingRestricted}
              cleaveOptions={{
                numeral: true,
                numeralDecimalScale: 2,
                numeralDecimalMark: ".",
                onValueChanged: (e) => {
                  handleChange({
                    target: {
                      name: "ach_same_day_fee",
                      value: e.target.rawValue,
                    },
                  });
                },
              }}
            />

            <TextInput
              label="Per ACH Web Transaction - Bank Account Validation Fee"
              name="ach_bank_validation_fee"
              type="text"
              prefix={"$"}
              inputMode="decimal"
              placeholder={achValidation.ach_bank_validation_fee.default}
              value={values.ach_bank_validation_fee}
              onBlur={handleBlur}
              onChange={() => { }}
              touched={touched?.ach_bank_validation_fee}
              errored={errors?.ach_bank_validation_fee}
              error={errors?.ach_bank_validation_fee}
              hasWarning={getSoftLimitWarning(
                pricingDefaults?.ach?.ach_bank_validation_fee?.soft_limit,
                values.ach_bank_validation_fee,
                errors.ach_bank_validation_fee,
              )}
              disabled={nonEditableTemplateOrPricingRestricted}
              cleaveOptions={{
                numeral: true,
                numeralDecimalScale: 2,
                numeralDecimalMark: ".",
                onValueChanged: (e) => {
                  handleChange({
                    target: {
                      name: "ach_bank_validation_fee",
                      value: e.target.rawValue,
                    },
                  });
                },
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ACHPricing;
